import React from 'react';
import Icon from '../../../assets/images/gotoback.svg';

export const IconGoToBack = (): JSX.Element => {
  return <img src={Icon} alt="Icone" />;
};
